import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL ?? '';
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

let companyClient: SupabaseClient | null = null;
let adminClient: SupabaseClient | null = null;

function assertConfig(): void {
  if (!url || !anonKey) {
    throw new Error(
      'Supabase client unavailable: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY',
    );
  }
}

// Company portal session (magic-link redeem flow). Distinct storage key so
// admin and company sessions can coexist in the same browser.
export function getSupabase(): SupabaseClient {
  if (!companyClient) {
    assertConfig();
    companyClient = createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'l2u-company-auth',
      },
    });
  }
  return companyClient;
}

// Admin portal session (email + password). Separate storage key.
export function getAdminSupabase(): SupabaseClient {
  if (!adminClient) {
    assertConfig();
    adminClient = createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'l2u-admin-auth',
      },
    });
  }
  return adminClient;
}
